import { can } from '../utils/memberPermissions';
import { useAuth } from '../contexts/AuthContext';
import React from 'react';
import { Link } from 'react-router-dom';
import InstallApp from '../components/InstallApp';
import { Users, Building2, Package, BarChart3, Settings, ChevronRight } from 'lucide-react';

const groups = [
  { title: 'People', destinations: [
    ['/contacts', 'Contacts', 'People and enquiry history', Users],
    ['/organisations', 'Organisations', 'Businesses and their contacts', Building2],
  ] },
  { title: 'Business tools', destinations: [
    ['/catalogue', 'Catalogue', 'Your products and services', Package],
    ['/reports', 'Reports', 'Sales performance and results', BarChart3],
  ] },
  { title: 'Workspace', destinations: [
    ['/settings', 'Settings', 'Account, team and connections', Settings],
  ] },
];

export default function More() {
  const { user } = useAuth();
  return <section className="space-y-6">
    <header>
      <h2 className="text-xl font-semibold tracking-tight text-gray-900">Your workspace</h2>
      <p className="mt-1 text-sm text-gray-600">Manage your people, business and preferences.</p>
    </header>
    <nav aria-label="More destinations" className="space-y-5">
      {groups.map(({ title: groupTitle, destinations }) => <section key={groupTitle} aria-label={groupTitle}>
        <h3 className="mb-2 px-1 text-xs font-semibold uppercase tracking-wider text-gray-500">{groupTitle}</h3>
        <div className="divide-y divide-gray-100 rounded-xl border border-gray-200 bg-white">
          {destinations.filter(([path]) => path !== '/reports' || can(user, 'viewReports')).map(([path, title, description, Icon]) => <Link
            key={path} to={path}
            className="group flex items-center gap-3 px-4 py-3 first:rounded-t-xl last:rounded-b-xl transition-colors hover:bg-primary-50 active:bg-primary-100 focus-visible:relative focus-visible:z-10">
            <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${groupTitle === 'Workspace' ? 'bg-gray-100 text-gray-600' : 'bg-primary-50 text-primary-700'}`}>
              <Icon aria-hidden="true" className="h-5 w-5" />
            </span>
            <span className="min-w-0 flex-1">
              <span className="block text-sm font-semibold text-gray-900">{title}</span>
              <span className="mt-0.5 block text-xs leading-5 text-gray-600">{description}</span>
            </span>
            <ChevronRight aria-hidden="true" className="h-4 w-4 shrink-0 text-gray-400 group-hover:text-primary-700" />
          </Link>)}
        </div>
      </section>)}
    </nav>
    <InstallApp className="focus-visible:outline-primary-600" />
  </section>;
}
